module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('span', [_c('v-menu', {
    attrs: {
      "offset-y": "",
      "close-on-content-click": false,
      "nudge-width": 60,
      "disabled": _vm.isReadOnly
    },
    model: {
      value: (_vm.startMenu),
      callback: function($$v) {
        _vm.startMenu = $$v
      },
      expression: "startMenu"
    }
  }, [_c('v-btn', {
    staticClass: "ds-button-tall ma-0 mb-2",
    attrs: {
      "slot": "activator",
      "depressed": ""
    },
    slot: "activator"
  }, [_vm._v("\n      " + _vm._s(_vm.startText) + "\n    ")]), _vm._v(" "), _c('div', {
    staticClass: "ds-span-menu"
  }, [_c('ds-day-picker', {
    attrs: {
      "highlight-span": _vm.hasStart,
      "span": _vm.startSpan
    },
    on: {
      "picked": _vm.setStart
    }
  }), _vm._v(" "), (_vm.hasStart) ? _c('v-btn', {
    staticClass: "mb-0",
    attrs: {
      "block": "",
      "flat": ""
    },
    on: {
      "click": function($event) {
        _vm.setStart(null)
      }
    }
  }, [_c('span', {
    domProps: {
      "innerHTML": _vm._s(_vm.labels.startless)
    }
  })]) : _vm._e()], 1)], 1), _vm._v("\n\n    to  \n\n  "), _c('v-menu', {
    attrs: {
      "offset-y": "",
      "close-on-content-click": false,
      "nudge-width": 60,
      "disabled": _vm.isReadOnly
    },
    model: {
      value: (_vm.endMenu),
      callback: function($$v) {
        _vm.endMenu = $$v
      },
      expression: "endMenu"
    }
  }, [_c('v-btn', {
    staticClass: "ds-button-tall ma-0 mb-2",
    attrs: {
      "slot": "activator",
      "depressed": ""
    },
    slot: "activator"
  }, [_vm._v("\n      " + _vm._s(_vm.endText) + "\n    ")]), _vm._v(" "), _c('div', {
    staticClass: "ds-span-menu"
  }, [_c('ds-day-picker', {
    attrs: {
      "highlight-span": _vm.hasEnd,
      "span": _vm.endSpan
    },
    on: {
      "picked": _vm.setEnd
    }
  }), _vm._v(" "), (_vm.hasEnd) ? _c('v-btn', {
    staticClass: "mb-0",
    attrs: {
      "block": "",
      "flat": ""
    },
    on: {
      "click": function($event) {
        _vm.setEnd(null)
      }
    }
  }, [_c('span', {
    domProps: {
      "innerHTML": _vm._s(_vm.labels.endless)
    }
  })]) : _vm._e()], 1)], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-b104ba6e","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/ScheduleSpan.vue
// module id = 185
// module chunks = 0